import * as ShoppingCartItem from './ShoppingCartItem';
import * as PriceBreakdown from './PriceBreakdown';
import { take } from "../util/takePayload";
export const getNew = () => ({
    token: '',
    items: [],
    dirty: false,
    priceBreakdown: PriceBreakdown.getNew(),
    controlQuantity: 0,
    total: 0,
});
export const fromGql = (gqlItem) => {
    var _a;
    return (Object.assign(Object.assign({}, take(gqlItem, 'controlQuantity', 'lockExpiresAt', 'total', 'token', 'notABotUntil')), { items: ((_a = gqlItem.items) === null || _a === void 0 ? void 0 : _a.map(ShoppingCartItem.fromGql)) || [], dirty: false, priceBreakdown: PriceBreakdown.fromGql(gqlItem.priceBreakdown) }));
};
//# sourceMappingURL=ShoppingCart.js.map